import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Shared renderer for assistant chat replies (SSU + Tara). The model replies in
// GitHub-Flavored Markdown; marked turns it into HTML and DOMPurify then strips
// anything outside the Markdown subset we render. The explicit allowlist enforces
// the assistant's "no raw HTML or images" contract: marked passes raw HTML
// through, so the allowlist is what guarantees only these Markdown-derived
// tags/attrs survive — no <img>, <span style>, <a target>, scripts, or event
// handlers. Keep this list as the single source of truth for both chat surfaces.
export const MARKDOWN_ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'hr',
  'strong', 'em', 'del', 'blockquote',
  'ul', 'ol', 'li', 'code', 'pre',
  'a', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
];

export const renderMessageHtml = (text) =>
  DOMPurify.sanitize(marked.parse(text || '', { gfm: true, breaks: true }), {
    ALLOWED_TAGS: MARKDOWN_ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'align'],
  });
